import { render, staticRenderFns } from "./EtcdInfoBanner.vue?vue&type=template&id=895569be&scoped=true&"
import script from "./EtcdInfoBanner.vue?vue&type=script&lang=js&"
export * from "./EtcdInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./EtcdInfoBanner.vue?vue&type=style&index=0&id=895569be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895569be",
  null
  
)

export default component.exports